import { render, staticRenderFns } from "./scope.vue?vue&type=template&id=97be8100&scoped=true&"
import script from "./scope.vue?vue&type=script&lang=js&"
export * from "./scope.vue?vue&type=script&lang=js&"
import style0 from "./scope.vue?vue&type=style&index=0&id=97be8100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97be8100",
  null
  
)

export default component.exports